import * as React from 'react';

const GraphChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 2h6v20H9V2zm2 2v16h2V4h-2zm5 4h6v14h-6V8zm2 2v10h2V10h-2zM2 12h6v10H2V12zm2 2v6h2v-6H4z"
            fill="#4B4D63"
        />
    </svg>
);

GraphChunkySvg.displayName = 'GraphChunkySvg';
export default GraphChunkySvg;
